import template from './branch.create.html';
import controller from './branch.create.controller';
import './branch.create.controller';

let branchcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default branchcreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch/create/branch.create.component.js